import { render, staticRenderFns } from "./StandardBlockContent.vue?vue&type=template&id=3529af02&"
import script from "./StandardBlockContent.vue?vue&type=script&lang=js&"
export * from "./StandardBlockContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports